import { render, staticRenderFns } from "./StaffSalary.vue?vue&type=template&id=c9d74bd4"
import script from "./StaffSalary.vue?vue&type=script&lang=js"
export * from "./StaffSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports